import { useState } from 'react';
import PropTypes from 'prop-types';
import { withValidation } from '@bingads-webui-react/validation';

const DummyIsOptionalComponent = ({ value, onChange }) => {
  const [isOptional, setIsOptional] = useState(value);

  if (value !== isOptional) {
    onChange({ target: { value } });
    setIsOptional(value);
  }

  return null;
};

DummyIsOptionalComponent.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.number.isRequired,
};

export const DummyIsOptionalValidationItem = withValidation(DummyIsOptionalComponent);

export const createValidationPropsForDummyItem = isOptionalValue => ({
  schema: {
    properties: {
      type: 'object',
      IsOptional: {
        type: 'bool',
      },
    },
  },
  field: 'IsOptional',
  data: { IsOptional: isOptionalValue },
});
